export enum RewardGameStatus { Active, Closed }
